import React from 'react';
import { motion } from 'framer-motion';
import Navigation from '../components/Navigation';
import HeroSection from '../sections/HeroSection';
// import AboutSection from '../sections/AboutSection';
import ProductUniverseSection from '../sections/ProductUniverseSection';
import WhySection from '../sections/WhySection';
import CaseStudiesSection from '../sections/CaseStudiesSection';
import InnovationSection from '../sections/InnovationSection';
import SustainabilitySection from '../sections/SustainabilitySection';
import MarketsSection from '../sections/MarketsSection';
// import GallerySection from '../sections/GallerySection';
import ResourceTeaserSection from '../sections/ResourceTeaserSection';
import FinderCtaSection from '../sections/FinderCtaSection';
import ContactSection from '../sections/ContactSection';
import Footer from '../components/Footer';
import CertStrip from '../components/CertStrip';

export default function Home() {
  return (
    <motion.main
      id="main"
      className="app-shell"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.45 }}
    >
      <Navigation />
      <HeroSection />
      <CertStrip />
      <ProductUniverseSection />
      <WhySection />
      <CaseStudiesSection />
      <InnovationSection />
      <SustainabilitySection />
      <MarketsSection />
      {/* <GallerySection /> */}
      <ResourceTeaserSection />
      <FinderCtaSection />
      {/* <AboutSection /> */}
      <ContactSection />
      <Footer />
    </motion.main>
  );
}
